import React, { useEffect, useState } from "react";
import CustomSelect from "../../ui/CustomSelect";
import MeasurementImage from "../../../assets/image/Measurement.svg";
import PlanningImage from "../../../assets/image/Planning.svg";
import Loader from "../../../loader/Loader";


export default function CustomerDetailsStep2({
  Services,
  inUAE,
  setInUAE,
  selectedService,
  customerFirstName,
  setCustomerFirstName,
  customerLastName,
  setCustomerLastName,
  customerPhone,
  setCustomerPhone,
  validatePhone,
  customerEmail,
  setCustomerEmail,
  validateEmail,

  referenceOptions,
  setMeasurementServiceDateforPlanning,
  referenceNumber,
  setReferenceNumber,
  setrefAvailable,
  showReference,
  refAvailable,
  showReferenceWarning,
  setShowReferenceWarning,
  ReferenceNumberValidation,
  isManualReferenceEntry,
  setIsManualReferenceEntry,
  goToStep,
  building,
  setBuilding,
  area,
  setArea,
  Emirateslist,
  selectedEmirate,
  handleEmirateChange,
  showErrors,
  error,
  emailError,
  selectedCity,
  setSelectedCity,
  selectedArea,
  setSelectedArea,
  loading,
  refs: {
    firstNameRef,
    lastNameRef,
    phoneRef,
    emailRef,
    buildingRef,
    areaRef,
    emirateRef,

    incountryRef,
    referencenumRef
  },
}) {


  const [areaOptions, setAreaOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [isCityLoading, setIsCityLoading] = useState(false);

  useEffect(() => {
    const fetchAreaCodes = async () => {
      let allAreaCodes = [];
      let offset = 0;
      let hasMore = true;

      while (hasMore) {
        try {
          const res = await fetch(`/server/ikea_services_function/areacode?offset=${offset}`);
          const json = await res.json();

          if (json.status === 'success') {
            const newAreaCodes = json.data.Areacode.map(item => ({
              value: item.AreaCode,
              label: item.AreaCode
            }));
            allAreaCodes = [...allAreaCodes, ...newAreaCodes];
            hasMore = json.data.hasMore;
            offset += json.data.Areacode.length;
          } else {
            hasMore = false;
            console.error('Error fetching area codes:', json.message);
          }
        } catch (err) {
          console.error('Error fetching area codes:', err);
          hasMore = false;
        }
      }
      setAreaOptions(allAreaCodes);
    };

    fetchAreaCodes();
  }, []);


  useEffect(() => {
    const fetchCitiesByArea = async () => {
      if (!selectedArea) {
        setCityOptions([]);
        return;
      }
      setIsCityLoading(true);
      let allCities = [];
      let offset = 0;
      let hasMore = true;

      while (hasMore) {
        try {
          const res = await fetch(`/server/ikea_services_function/citylist?areacode=${selectedArea.value}&offset=${offset}`);
          const json = await res.json();

          if (json.status === 'success') {
            const newCities = json.data.CityList.map(item => ({
              value: item.City,
              label: item.City
            }));
            allCities = [...allCities, ...newCities];
            hasMore = json.data.hasMore;
            offset += json.data.CityList.length;
          } else {
            hasMore = false;
            console.error('Error fetching cities:', json.message);
          }
        } catch (err) {
          console.error('Error fetching cities:', err);
          hasMore = false;
        }
      }
      setCityOptions(allCities);
      setIsCityLoading(false);
    };

    fetchCitiesByArea();
  }, [selectedArea]);


  const getServiceImage = (serviceName) => {
    if (serviceName.toLowerCase().includes("measurement")) {
      return MeasurementImage;
    } else if (serviceName.toLowerCase().includes("planning")) {
      return PlanningImage;
    }
    return null;
  };

  return (
    <div className="step-2">
      <div className="select-info">
        {Services.filter(
          (s) => s.ServiceName === selectedService.ServiceName
        ).map((service, index) => (
          <React.Fragment key={service.ServiceCode || index}>
            <div className="service-header-row">
              <h4>{service.ServiceName}</h4>
              {getServiceImage(service.ServiceName) && (
                <img
                  src={getServiceImage(service.ServiceName)}
                  alt={service.ServiceName}
                  className="service-image"
                />
              )}
              <div className="service-meta">
  <div className="price-container">
    <div className="price">
      <span className="currency-sup">Dhs</span>
      {service.Price?.toString().includes(".") ? (
        <>
          {service.Price.toString().split(".")[0]}
          <span className="decimal-sub">
            .{service.Price.toString().split(".")[1]}
          </span>
        </>
      ) : (
        service.Price
      )}
    </div>

    {service.ServiceName.toLowerCase().includes("measurement") && (
      <>
        <div className="price-sub">
          for the first room
        </div>
        <div className="price-sub light">
          + Dhs 50 per additional room
        </div>
      </>
    )}
  </div>
</div>
            </div>

            <p>{service.Description}</p>
          </React.Fragment>
        ))}
      </div>

      <div className="customer-info">


        <div className="form-group">
          <label className="required">Name</label>
          <div className="input-group">
            <div className={`field-wrapper ${showErrors && !customerFirstName.trim() ? "has-error" : ""}`}>
              <input
                ref={firstNameRef}
                type="text"
                placeholder="First Name"
                value={customerFirstName}
                onChange={(e) => setCustomerFirstName(e.target.value)}
              />
              {showErrors && !customerFirstName.trim() && (
                <p className="error-text">First name is required</p>
              )}
            </div>

            <div className={`field-wrapper ${showErrors && !customerLastName.trim() ? "has-error" : ""}`}>
              <input
                ref={lastNameRef}
                type="text"
                placeholder="Last Name"
                value={customerLastName}
                onChange={(e) => setCustomerLastName(e.target.value)}
              />
              {showErrors && !customerLastName.trim() && (
                <p className="error-text">Last name is required</p>
              )}
            </div>
          </div>
        </div>

        <div className="form-group">
          <label className="required">Are you currently in the UAE?</label>
          <div className="toggle-group" ref={incountryRef}>
            <label className={`toggle-option ${inUAE ? 'active' : ''}`}>
              <input
                type="radio"
                name="location"
                value="in"
                checked={inUAE}
                onChange={() => setInUAE(true)}
              />
              In Country
            </label>
            <label className={`toggle-option ${!inUAE ? 'active' : ''}`}>
              <input
                type="radio"
                name="location"
                value="out"
                checked={!inUAE}
                onChange={() => setInUAE(false)}
              />
              Out of Country
            </label>
          </div>
        </div>
 <div
          className={`form-group ${
            showErrors && !customerEmail.trim() ? "has-error" : ""
          }`}
        >
          <label className="required">Email</label>
          <input
            ref={emailRef}
            type="email"
            placeholder="Email address (e.g. name@domain.com)"
            value={customerEmail}
            onChange={(e) => setCustomerEmail(e.target.value)}
            onBlur={(e) => validateEmail(e.target.value)}
          />
          {emailError && <p className="error-text">{emailError}</p>}
        </div>
        {<div className={`form-group ${showErrors && !customerPhone.trim() ? "has-error" : ""}`}>
  <label className="required">Phone Number</label>
  <div className="phone-input-wrapper">
    <span className="phone-prefix">+971</span>
    <input
      ref={phoneRef}
      type="tel"
      inputMode="numeric"
      pattern="[0-9]*"
      maxLength={9}
      placeholder="501234567"
      value={customerPhone}
      onChange={(e) => {
        const digitsOnly = e.target.value.replace(/\D/g, "");
        setCustomerPhone(digitsOnly);
      }}
      onBlur={(e) => validatePhone(e.target.value)}
      className="phone-input"
    />
  </div>
  {error && <p className="error-text">{error}</p>}
</div>
}
{
          loading&& <Loader/>
        }

        {showReference && (
  <div className={`form-group ${showErrors && (!referenceNumber || !refAvailable) ? 'has-error' : ''}`}>
    <label>Reference Number / Transaction ID (of Measurement Service)</label>

    {referenceOptions.length > 0 ? (
      <CustomSelect
        options={referenceOptions.map(opt => ({
          value: opt.value,
          label: opt.label,
        }))}
        value={referenceOptions.find(opt => opt.value === referenceNumber)}
       onChange={(selected) => {
  const label = selected.label;

  const match = label.match(/^(\S+)\s+\(([^)]+)\)$/);
const value = match ? match[1] : selected.value;
const date = match ? match[2] : "";

let parsedDate = null;
if (date) {
  const [day, month, year] = date.split("/").map(Number);
  parsedDate = new Date(year, month - 1, day);
}

setReferenceNumber(value);
setrefAvailable(true);
setMeasurementServiceDateforPlanning(parsedDate);
}}
        placeholder="Select Reference Number"
      />
    ) : (
      <input
        ref={referencenumRef}
        type="text"
        disabled={!isManualReferenceEntry}
        value={referenceNumber}
        onChange={(e) => setReferenceNumber(e.target.value)}
        onBlur={(e) => {
          if (
            selectedService?.ServiceName === "Kitchen Planning Service" &&
            e.target.value.trim()
          ) {
            ReferenceNumberValidation(e.target.value.trim());
          }
        }}
        placeholder="Enter Reference Number"
        className="input-field"
        maxLength={15}
      />
    )}

    {showErrors && !referenceNumber && (
      <p className="error-text">Reference number is required</p>
    )}
    {showErrors && referenceNumber && !refAvailable && (
      <p className="error-text">Entered reference number is invalid or not found</p>
    )}
  </div>
)}


        <div className={`form-group ${showErrors && (!selectedArea?.value || !selectedCity?.value || !building.trim()) ? "has-error" : ""}`}>
         <label className="required">Address</label>
         <div className="more-group"ref={areaRef}>

              <CustomSelect
                placeholder="Select Area"
                options={areaOptions}
                value={selectedArea}
                onChange={(value) => {
                  setSelectedArea(value);
                  setArea(value?.value || "");
                }}
              />

            <div ref={emirateRef}>
              {isCityLoading ? (
                <div className="loader-container">
                  <Loader />
                </div>
              ) : (
                <CustomSelect
                  placeholder="Select City"
                  options={cityOptions}
                  value={selectedCity}
                  onChange={(value) => setSelectedCity(value)}
                />
              )}
            </div>

            <input
              ref={buildingRef}
              type="text"
              placeholder="Building Name / Flat No. / Street"
              value={building}
              onChange={(e) => setBuilding(e.target.value)}
            />
          </div>
          {showErrors && !selectedArea?.value && <p className="error-text">Area is required</p>}
          {showErrors && selectedArea?.value && !selectedCity?.value && <p className="error-text">City is required</p>}
          {showErrors && !building.trim() && <p className="error-text">Address is required</p>}
        </div>
      </div>
      <div>
</div>


      {!inUAE && (
        <div className="dialog-overlay">
          <div className="dialog-box">
            <h3>Booking Unavailable</h3>
            <p>
              If you are currently <strong>outside the UAE</strong>, please contact our{" "}
              <strong>Service Center</strong> at <a href="tel:8004532">800 4532</a> to complete your booking.
            </p>
            <button className="dialog-close-button" onClick={() => setInUAE(true)}>
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
